import firebase from "firebase/app";

//firebase.initializeApp(firebaseConfig);

export default firebase;